import React, { useState } from "react";
import Select from "react-select";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  setLenderID,
  setSelectedAccount,
  setSelectedRole,
  setAccountOptions,
} from "../../store/reducers/accountSlice";
import { setReportList, setRoute } from "../../store/reducers/reducer-auth";
import { useDispatch, useSelector } from "react-redux";
import { setDashboardStatus } from "../../store/reducers/dashboardSlice";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { BlurWrapper } from "../../Utils/CustomComponent";

const AccountComp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const selectedRoleObj = useSelector((state) => state.account.selectedRole);
  const lenderId = useSelector((state) => state.account.lenderId);

  const selectedRoleValue = useSelector(
    (state) => state.account.selectedRole.value
  );
  const roleOptions = useSelector((state) => state.account.roleOptions);
  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade
  );

  const [localAccountOptions, setLocalAccountOptions] =
    useState(accountOptions);
  const [localSelectedAccount, setLocalSelectedAccount] =
    useState(selectedAccount);
  const [localLenderId, setLocalLenderId] = useState(lenderId);
  const [localSelectedRole, setLocalSelectedRole] = useState(selectedRoleObj);

  const handleRoleSubmit = () => {
    // const detailRole = JSON.parse(
    //   JSON.parse(localStorage?.getItem("user-details"))?.details?.roles
    // )?.filter((data) => data?.role_type === selectedRoleValue)[0];
    const detailRole = JSON.parse(
      JSON.parse(localStorage?.getItem("user-details"))?.details?.roles
    )?.filter((data) => data?.role_type === localSelectedRole?.value)[0];

    const updatedRoute = detailRole?.nav_menu
      ?.sort((a, b) => a?.menu_order - b?.menu_order)
      ?.map((data) => data?.menu_name) || ["Account"];

    const reportNameList = detailRole?.report_list;

    dispatch(setSelectedRole(localSelectedRole));
    dispatch(setAccountOptions(localAccountOptions));
    dispatch(setSelectedAccount(localSelectedAccount));
    dispatch(setLenderID(localLenderId));

    dispatch(setRoute(updatedRoute));
    dispatch(setReportList(reportNameList));
    dispatch(setDashboardStatus("idle"));
    navigate("/");
  };

  const handleRoleChange = (e) => {
    // dispatch(setSelectedRole(e));
    setLocalSelectedRole(e);

    const isBorrower = e?.label?.includes("Borrower");

    const selectedRoleAccountOptions = JSON.parse(
      localStorage?.getItem("accessed_user")
    )
      .account?.filter((data) => data.type === e.value)
      ?.map((data) => ({
        label:
          isBorrower && data?.paidoff_yn?.toLowerCase() === "y"
            ? `${data?.fullname} : ${data?.account} : ${data?.paidoffdate}`
            : `${data?.fullname} : ${data?.account}`,
        value: data.recid,
        databasename: data.databasename,
      }));
    if (selectedRoleAccountOptions?.length) {
      setLocalAccountOptions(selectedRoleAccountOptions);
      setLocalSelectedAccount(selectedRoleAccountOptions[0]);
      setLocalLenderId(selectedRoleAccountOptions[0]?.value);

      // dispatch(setAccountOptions(selectedRoleAccountOptions));
      // dispatch(setSelectedAccount(selectedRoleAccountOptions[0]));
      // dispatch(setLenderID(selectedRoleAccountOptions[0]?.value));
    } else {
      setLocalAccountOptions([]);
      setLocalSelectedAccount({});
      setLocalLenderId("");

      // dispatch(setAccountOptions([]));
      // dispatch(setSelectedAccount({}));
      // dispatch(setLenderID(""));
    }
  };
  const handleAccountChange = (e) => {
    setLocalSelectedAccount(e);
    setLocalLenderId(e?.value);

    // dispatch(setSelectedAccount(e));
    // dispatch(setLenderID(e?.value));
    // dispatch(setDashboardStatus("idle"));
    // toast.success("Account Changed", {
    //   ...commonToast,
    // });
  };
  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eee", minHeight: "92vh" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0 mt-1">
            <h4>Account</h4>
          </div>
        </article>
        {accountOptions?.length ? (
          <>
            {!masqueradeEmail.isIt && (
              <article className="container-fluid">
                <section
                  style={{ minHeight: "fit-content" }}
                  className="bg-white p-5  mx-4 h-50 row account-button"
                >
                  <div className="col-sm-4 col-md-4 col-lg-2 p-3 pb-0 mt-1">
                    <h4>Add Account</h4>
                  </div>
                  <div className="col-sm-8 col-md-8">
                    <Button
                      onClick={() => {
                        navigate("/add_account");
                      }}
                    >
                      Add acccount
                    </Button>
                  </div>
                  <div className="col-sm-4"></div>
                </section>
              </article>
            )}
            <article className="container-fluid">
              <section
                style={{ minHeight: "fit-content" }}
                className="bg-white p-5  mx-4 h-50 row change-account"
              >
                <div className="col-sm-4 col-md-4 col-lg-2 p-3 pb-0 mt-1">
                  <h4>Change Account</h4>
                </div>
                <div className="col-sm-8">
                  <BlurWrapper>
                    <Select
                      // options={accountOptions}
                      options={localAccountOptions}
                      // value={selectedAccount ? selectedAccount : null}
                      value={localSelectedAccount ? localSelectedAccount : null}
                      onChange={handleAccountChange}
                      classNamePrefix="select"
                    />
                  </BlurWrapper>
                </div>
              </section>
            </article>
          </>
        ) : null}
        <article className="container-fluid">
          <section
            className="bg-white p-5  mx-4 h-50 row update-role"
            style={{ minHeight: "40vh" }}
          >
            <div className="col-sm-2 p-3 pb-0 mt-1">
              <h4>Update Role</h4>
            </div>
            <div className="col-sm-6">
              <Select
                options={roleOptions}
                // value={selectedRoleObj ? selectedRoleObj : null}
                value={localSelectedRole ? localSelectedRole : null}
                onChange={handleRoleChange}
                classNamePrefix="select"
              />
            </div>
            <div className="col-sm-4">
              <Button
                // disabled={selectedRoleObj?.length < 1}
                disabled={Object.keys(localSelectedRole)?.length < 1}
                onClick={handleRoleSubmit}
              >
                Submit
              </Button>
            </div>
          </section>
        </article>
      </section>
    </div>
  );
};

export default AccountComp;
